import { useFormikContext } from "formik";
import { debounce, cloneDeep } from "lodash";
import { omit } from "lodash";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CellTool } from "../../models/collaborate.model";
import {
    NodeState,
    updateRigidCellTool,
    updateSelectedCellToolWishList
} from "../../store/slices/node.slice";
import { setSelectedTestTool } from "../../store/slices/tools.slice";

export default function SelectedTestToolArgumentsAutoSave({ debounceMs }) {
    const formikContext = useFormikContext();
    const dispatch = useDispatch();
    const selectedTestTool: CellTool = useSelector((state: any) => state.tools.selectedTestTool);
    const nodesDataState: NodeState = useSelector((state: any) => state.nodeData);

    // Debounced function to send the request to the server
    const debouncedSave = useCallback(
        debounce(async (values) => {
            const selectedTestToolCopy: CellTool = cloneDeep(selectedTestTool);
            const persistTestValues = values.$persistTestValues;
            const formValues = omit(cloneDeep(values), ["$persistTestValues"]);

            for (const key of Object.keys(formValues)) {
                if (!values[key]) {
                    continue;
                }
                selectedTestToolCopy.arguments_object[key].default_value = formValues[key];
            }

            dispatch(setSelectedTestTool(selectedTestToolCopy as CellTool));
            /**
             * If persistValues is set, update the selected tool in the cell values..
             */
            if (persistTestValues) {
                // Omit temporary test values
                // update state
                if (nodesDataState.collabApp?.type === "rigid") {
                    dispatch(
                        updateRigidCellTool({
                            selected_tool: selectedTestToolCopy
                        })
                    );
                } else {
                    // dispatch(updateCellTool(selectedTestToolCopy));
                    dispatch(
                        updateSelectedCellToolWishList({
                            selected_tool: selectedTestToolCopy
                        })
                    );
                }
            }
        }, debounceMs),
        []
    );

    // Observe the Formik values and trigger the debounced function on change
    useEffect(() => {
        debouncedSave(formikContext.values);
        // Return a cleanup function to cancel debounced calls if component unmounts
        return debouncedSave.cancel;
    }, [formikContext.values, debouncedSave]);

    return null;
}
